import React, { Component } from 'react'
import { Modal, Button, Select } from 'advenio-components'
import styled from 'styled-components'
import {
  clone,
  isEmpty,
} from 'ramda'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import { NameHeader, Close, Save, Img } from './ModalAssessment.styles'
import CheckinInventoryActions from '../../Data/Redux/CheckinInventoryRedux'
import { generateSelectOptions } from '../../utils/Utils'
import CheckoutModal from './CheckoutModal'

const Content = styled.div`
  flex: 1;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 763px) {
    height: calc(100vh - 100px);
    overflow-y: scroll;
    display: block;
  }
`
const HeaderTitle = styled.div`
  flex: 1;
  height: 80px;
  border-bottom: solid 1px;
  border-bottom-color: #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`
const NameSpan = styled.span`
  color: #4a4a4a;
`
const HeaderSpan = styled.span`
  font-size: 14px;
`
const DiaperContainer = styled.div`
  width: 100%;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 763px) {
    height: auto;
  }
`
const DiaperDiv = styled.div`
  width: 90%;
  height: 100px;
  background-color: #e2e8ec;
  border-radius: 4px;
  margin-bottom: 20px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  @media (max-width: 763px) {
    margin-top: 0;
    width: 100%;
    height: auto;
    flex-direction: column;
  }
`
const SelectDiv = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const Profile = styled.div`
  background-image: ${props =>
    props.profile ? `url(${props.profile})` : 'url(/assets/BabyAvatar.svg)'};
  background-size: cover;
  background-position: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: solid #cccccc 1px;
  margin-right: 4px;
`
const FoodStuffContainer = styled.div`
  width: 90%;
  height: 240px;
  display: flex;
  flex-direction: column;
  @media (max-width: 763px) {
    height: auto;
    width: 100%;
  }
`
const SelectAllFood = styled.div`
  width: 100%;
  height: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-direction: row;
  margin-bottom: 5px;
  @media (max-width: 763px) {
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
`
const FoodStuff = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

const Check = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 10px;
`
export const IconsDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
`
const CheckContainer = styled.div`
  height: 50px;
  width: 190px;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => (props.selected ? '#3b99fc' : '')};
  margin-left: 5px;
  margin-right: 5px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-radius: 3%;
  border: solid 1px #cccccc;
  @media (max-width: 763px) {
    margin-bottom: 5px;
  }
`
const Buttons = styled.button`
  color: ${props => (props.selected ? '#FFF' : '')};
  background-color: transparent;
  padding: 8px 20px;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
`

class CheckinModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      width: window.innerWidth,
      inventory: [],
      accessories: [],
      consumables: [],
      diapers: 0,
      diapersSelected: '',
      clothes: 0,
      clothesSelected: '',
      bags: 0,
      bagsSelected: '',
      selectAllAccessories: false,
      selectAllConsumables: false,
      options: this.props.fillOptions(10),
      optionsDiaper: this.props.fillOptions(40),
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && nextProps.type !== 'checkout') {
      const consumables = clone(nextProps.consumables)
      if (nextProps.consumables) {
        for (let i = 0; i < consumables.length; i++) {
          consumables[i].selected = false
        }
      }
      this.setState({ consumables })
      if (nextProps.child !== this.props.child) {
        if (nextProps.open) {
          this.props.getCheckinInventory(nextProps.child.id)
        }
      }
      if (nextProps.child.id) {
        if (nextProps.child.checkin.inventory_completed) {
          if (nextProps.checkinInventory.id) {
            const inventory = nextProps.checkinInventory
            this.setState({ inventory })
            if (inventory) {
              const bags = inventory.checkin_list.bags
              const clothes = inventory.checkin_list.change_of_clothes
              const diapers = inventory.checkin_list.diapers
              if (inventory.checked_in_items.length > 0) {
                const newState = { ...this.state }
                for (let i = 0; i < newState.consumables.length; i++) {
                  newState.consumables[i].selected = false
                }
                for (let i = 0; i < inventory.checked_in_items.length; i++) {
                  for (let j = 0; j < newState.consumables.length; j++) {
                    if (inventory.checked_in_items[i] === newState.consumables[j].id) {
                      newState.consumables[j].selected = true
                    }
                  }
                }
                newState.bagsSelected = bags
                newState.diapersSelected = diapers
                newState.clothesSelected = clothes
                this.setState(newState)
              } else {
                this.setState({
                  bagsSelected: bags,
                  diapersSelected: diapers,
                  clothesSelected: clothes,
                })
              }
            }
          }
        } else {
          this.setState({ bagsSelected: '', diapersSelected: '', clothesSelected: '' })
        }
      }
    } else {
      const newState = { ...this.state }
      for (let i = 0; i < newState.consumables.length; i++) {
        newState.consumables[i].selected = false
      }
      this.setState(newState)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getConsumables = () => {
    const { consumables } = this.state

    return consumables
      ? consumables.map((currentValue, index, array) => (
          //eslint-disable-line
        <CheckContainer key={index} selected={currentValue.selected}>
          <Input
            ref={input => (this.clickItem = input)}
            onClick={this.clickConsumables}
            id={currentValue.id}
            type="radio"
          />
          <Buttons onClick={() => this.clickItem.click()} selected={currentValue.selected}>
            <Check
              src={
                currentValue.selected ? '/assets/check_mark.svg' : '/assets/blank_check_mark.svg'
              }
            />
            {currentValue.name}
          </Buttons>
        </CheckContainer>
      ))
      : null
  }

  clickConsumables = (e) => {
    const id = e.target.id
    const newState = { ...this.state }
    for (let i = 0; i < newState.consumables.length; i++) {
      if (newState.consumables[i].id == id) {
        newState.consumables[i].selected = !newState.consumables[i].selected
      }
    }
    this.setState(newState)
  }

  closeModal = () => {
    if (this.props.type === 'checkin') {
      this.props.closeCheckIn()
    } else {
      this.props.closeCheckOut()
    }
  }

  updateWindowDimensions = () => this.setState({ width: window.innerWidth })

  toggleConsumables = () => {
    const {
      consumables,
      selectAllConsumables: selectAll,
    } = this.state
    const selectAllConsumables = !selectAll
    consumables.forEach((consumable) => {
      consumable.selected = selectAllConsumables
    })

    this.setState({
      selectAllConsumables,
      consumables,
    })
  }

  send = (data) => {
    const {
      checkinInventory,
      child,
      isTeacher,
      postStudentCheckIn,
      postStudentCheckOut,
      type,
      updateCheckinInventory,
    } = this.props
    const {
      accessories,
      consumables,
    } = this.state

    const consumablesToSend = consumables.filter(consumable => consumable.selected)
      .map(consumable => ({ item_id: consumable.id }))
    const accessoriesToSend = accessories.filter(accessory => accessory.selected)
      .map(accessory => ({ item_id: accessory.id }))

    const params = {
      diapers: data.pañales,
      change_of_clothes: data.cambio,
      bags: data.bolsas,
      inventory_items: [...consumablesToSend, ...accessoriesToSend],
    }

    if (type === 'checkin') {
      if (isEmpty(checkinInventory)) {
        window.gtag('event', 'Health Checkin', {
          event_category: 'Check',
          event_label: 'click Health Check',
          // value: Number(id)
            })
        return postStudentCheckIn(child.checkin.id, params)
      }
      window.gtag('event', 'Health Checkin', {
        event_category: 'Check',
        event_label: 'click  Update Health Check',
        // value: Number(id)
          })
      return updateCheckinInventory(child.checkin.id, params)
    }
    window.gtag('event', 'Checkout2', {
      event_category: 'Check',
      event_label: 'click Checkout2',
      // value: Number(id)
        })
    return postStudentCheckOut(child.checkin, params, isTeacher)
  }

  highStudyProgramCheckout = () => {
    const {
      child,
      isTeacher,
      postStudentCheckOut,
    } = this.props
    const params = {
      diapers: 0,
      change_of_clothes: 0,
      bags: 0,
      inventory_items: [],
    }

    postStudentCheckOut(child.checkin, params, isTeacher)
  }

  studyProgram = (studyProgramId) => {
    const {
      programLevels,
      studyPrograms,
    } = this.props

    if (!studyProgramId) return false

    const studyProgram = studyPrograms.find(program => program.id === studyProgramId)
    const level = programLevels.find(levelProgram => levelProgram.id === studyProgram.level_id)

    return level && level.name !== 'Guardería'
  }

  renderCheckIn = () => {
    const {
      child,
      loading,
      type,
    } = this.props
    const {
      bagsSelected,
      diapersSelected,
      clothesSelected,
      options,
      selectAllConsumables,
      width,
    } = this.state

    return (
      <Form onSubmit={this.send}>
        <HeaderTitle>
          <Close>
            <Img src="/assets/Close.svg" onClick={this.closeModal} />
          </Close>
          <HeaderSpan>
            {type === 'checkin' ? 'Formato de Entrada' : 'Formato de salida'}
          </HeaderSpan>
          <NameHeader>
            <Profile profile={child.profile_image} />
            <NameSpan>
              {`${child.first_name} ${child.last_name_paternal}`}
            </NameSpan>
          </NameHeader>
          <Save>
            <Button
              small
              style={
                width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}
              }
              primary
              type="submit"
              loading={loading}
            >
              Confirmar
            </Button>
          </Save>
        </HeaderTitle>
        <Content>
          <DiaperContainer>
            <DiaperDiv>
              <SelectDiv>
                <Select
                  name="pañales"
                  label="Pañales"
                  value={diapersSelected !== '' ? diapersSelected : '0'}
                  options={options}
                />
              </SelectDiv>
              <SelectDiv>
                <Select
                  name="cambio"
                  label="Cambio de Ropa"
                  value={clothesSelected !== '' ? clothesSelected : '0'}
                  options={options}
                />
              </SelectDiv>
              <SelectDiv>
                <Select
                  name="bolsas"
                  label="Bolsas"
                  value={bagsSelected !== '' ? bagsSelected : '0'}
                  options={options}
                />
              </SelectDiv>
            </DiaperDiv>
          </DiaperContainer>
          <FoodStuffContainer>
            <SelectAllFood>
              <span style={{ marginRight: '10px' }}>Comestibles</span>
              <span
                style={{ color: '#3E72D7', cursor: 'pointer' }}
                onClick={this.toggleConsumables}
              >
                {selectAllConsumables ? 'Deseleccionar Todos' : 'Seleccionar Todos'}
              </span>
            </SelectAllFood>
            <FoodStuff>{this.getConsumables()}</FoodStuff>
          </FoodStuffContainer>
        </Content>
      </Form>
    )
  }

  render() {
    return (
      <Modal
        isOpened={this.props.open}
        full={this.state.width < 763}
        onClose={this.closeModal}
        statePath="inventory"
        actionType="sending"
        typePrefix="INVENTORY"
      >
        {this.props.type !== 'checkin' ? <CheckoutModal {...this.props} /> : this.renderCheckIn()}
      </Modal>
    )
  }
}

CheckinModal.propTypes = {
  closeCheckIn: PropTypes.func,
  /** Callback function to be fired when updating the Checkin Inventory */
  updateCheckinInventory: PropTypes.func,
  /** Return the options for selects (diaper, change of clothes and bag) */
  fillOptions: PropTypes.func.isRequired,
}

CheckinModal.defaultProps = {
  closeCheckIn: () => {},
  updateCheckinInventory: () => {},
}

const mapStateToProps = state => ({
  checkinInventory: state.checkin_inventory.get.results,
  programLevels: state.programLevels.get.results,
})

const mapDispatchToProps = dispatch => ({
  getCheckinInventory: studentId => dispatch(CheckinInventoryActions.getRequest(studentId, true)),
  fillOptions: length => generateSelectOptions(length),
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CheckinModal),
)



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/CheckInModal.jsx